import { render, staticRenderFns } from "./BuildingDelete.vue?vue&type=template&id=6124a394&scoped=true&"
import script from "./BuildingDelete.vue?vue&type=script&lang=js&"
export * from "./BuildingDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6124a394",
  null
  
)

export default component.exports